module.exports = __webpack_public_path__ + "img/variables-hipotesis.35c6051d.png";